<template>
  <div class="content">
    <div class="cardContent">
      <div class="detailsClass">
        <p>
          <span class="span-l">ICCID：</span>
          <span class="span-r">{{detailsData.iccid}}</span>
        </p>
        <!-- <p>
          <span class="span-l">MSISDN：</span>
          <span class="span-r">{{detailsData.msisdn}}</span>
        </p> -->
        <p>
          <span class="span-l">签约账号：</span>
          <span class="span-r">{{detailsData.appName}}</span>
        </p>
        <p>
          <span class="span-l">签约单号：</span>
          <span class="span-r">{{detailsData.outAgreementNo}}</span>
        </p>
        <p>
          <span class="span-l">签约手机号：</span>
          <span class="span-r">{{detailsData.phone}}</span>
        </p>
        <p>
          <span class="span-l">用户账户：</span>
          <span class="span-r">{{detailsData.agreementAccount}}</span>
        </p>
        <p>
          <span class="span-l">签约套餐：</span>
          <span class="span-r">{{detailsData.productName}}</span>
        </p>
        <p>
          <span class="span-l">签约状态：</span>
          <span class="span-r">{{detailsData.status}}</span>
        </p>
        <p>
          <span class="span-l">签约价格：</span>
          <span class="span-r">{{detailsData.price}}</span>
        </p>
        <p>
          <span class="span-l">续费价格：</span>
          <span class="span-r">{{detailsData.renewalPrice}}</span>
        </p>
        <p>
          <span class="span-l">首次扣款时间：</span>
          <span class="span-r">{{detailsData.firstDebitTime}}</span>
        </p>
        <p>
          <span class="span-l">下次扣款时间：</span>
          <span class="span-r">{{detailsData.nextDebitTime}}</span>
        </p>
        <p>
          <span class="span-l">最后扣款时间：</span>
          <span class="span-r">{{detailsData.lastDebitTime}}</span>
        </p>
        <p>
          <span class="span-l">签约时间：</span>
          <span class="span-r">{{detailsData.createTime}}</span>
        </p>
        <p>
          <span class="span-l">解约时间：</span>
          <span class="span-r">{{detailsData.unSignTime}}</span>
        </p>


      </div>
      <div class="buttonClass">
        <el-button type="primary" size="medium" @click="rescindButton()">解约按钮</el-button>
        <el-button type="danger" size="medium" @click=" updateButton()">更新数据</el-button>
      </div>
      <div class="tabClass">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="扣款列表" name="first">
            <deductionList ref="deductionListRef"></deductionList>
          </el-tab-pane>
          <el-tab-pane label="订单列表" name="second">
            <renewalDetailsOrderList ref="renewalDetailsOrderListRef"></renewalDetailsOrderList>
          </el-tab-pane>
          <el-tab-pane label="变更列表" name="third">
            <renewalChangeList ref="renewalChangeListRef"></renewalChangeList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import { agreementRemoveAgreement } from "@/api/api.js"; //解约
import { agreementQueryAgreement } from "@/api/api.js"; //更新
import { agreementAgreementDetail } from "@/api/api.js"; //初始化数据
import deductionList from "@/views/userCenter/deductionList.vue";
import renewalDetailsOrderList from "@/views/userCenter/renewalDetailsOrderList.vue";
import renewalChangeList from "@/views/userCenter/renewalChangeList.vue";
export default {
  data() {
    return{
      activeName: "first",
      detailsData:{}
    }
  },
  components:{
    deductionList,
    renewalDetailsOrderList,
    renewalChangeList
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        id:this.$route.query.id
      };
      agreementAgreementDetail(params).then(res=>{
        if(res.data.code == 200){
          this.detailsData = res.data.data;
          let packageData= JSON.parse(this.detailsData.productInfo);
          this.detailsData.productName = packageData.productName;
          this.detailsData.renewalPrice = packageData.renewalPrice;
          this.detailsData.unSignTime = this.detailsData.unSignTime == null ? "无" :this.detailsData.unSignTime;
          this.detailsData.status = this.detailsData.status == "1" ? "已签约" : "已解约"
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    // tab切换
    handleClick(tab){
      if(tab.name == "first"){
        this.$refs.deductionListRef.initData();
      }else if(tab.name == "second"){
        this.$refs.renewalDetailsOrderListRef.initData();
      }else if(tab.name == "third"){
        this.$refs.renewalChangeListRef.initData()
      }
    },
    // 解约按钮
    rescindButton(){
      if (this.detailsData.status == "已解约")  return this.$message.warning("已解约的卡不允许再次解约");
      this.$alert("确定要解约吗？", "解约", {
        confirmButtonText: "确定"
      }).then(() => {
        let params = {
          id:this.$route.query.id
        }
        agreementRemoveAgreement(params).then(res => {
          if (res.data.code == 200) {
            this.initData();
            this.$notify({
              title: "成功",
              message: "解约成功",
              type: "success"
            });
          }else{
            this.$message.error(res.data.message);
          }
        });
      }).catch(() => {});
    },
    // 更新按钮
    updateButton(){
      let params = {
        id:this.$route.query.id
      };
      agreementQueryAgreement(params).then(res => {
        if (res.data.code == 200) {
          this.initData();
          this.$notify({
            title: '成功',
            message: '用户信息更新成功！',
            type: 'success'
          });
        }else{
          this.$message.error(res.data.message);
        }
      })
    },

  },

  mounted() {
    this.initData();
  },
  created() {
    
  }
};
</script>

<style scoped lang="less">
  .cardContent{
    padding: 0 20px;
  }
  .detailsClass{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    p{
      width: 33.3%;
      padding: 10px 0;
      font-size: 14px;
      .span-l{
        display: inline-block;
        width: 30%;
        text-align: left;
        color: #606266;
      }
      .span-r{
        display: inline-block;
        width: 70%;
        color: #1890ff;
      }
    }
  }
  .buttonClass{
    margin-top: 18px;
  }
  .tabClass{
    margin-top: 18px;
    padding-bottom: 40px;
  }
  @media screen and (max-width: 750px){
    .detailsClass p{
      width: 100% !important;
    }
  }
  @media screen and (min-width: 750px)and (max-width: 1310px){
  .detailsClass p{
    width: 50% !important;
  }
}
</style>


